<template>

  <div class="pb" v-if="diaryData && allowEdit">
    <h1 class="title">
      {{ isNewDiary ? $t('create_diary_view_title') : $t('create_diary_view_title_edit') }}
    </h1>


    <!-- <div class="hints-toggle">
      <span>Show supporting text throughout the page for clarity and guidance</span>
      <UiToggleV2
          v-model="isShowHints"
      />
    </div> -->

    <h3 ref="elDiarySignup" v-if="!useAuth().isAuth()">
      {{ $t('signup_view_title') }}
    </h3>

    <GeneralSignupShort 
      v-if="!useAuth().isAuth()"
      ref="signupShortRef"
      @signup-success="save"
      @signup-error="handleSignupError"
    />


    <template v-if="isLoadedPresaver">
      <UiMessage
        type="blue"
        :button-name="$t('create_week_view_presave_clear')"
        :button-type="'link'"
        @click-button="presaveClear"
        >
        <b>{{ $t('create_week_view_loaded_from_previous_edit') }}</b>
      </UiMessage>
    </template>
    


    <div class="head_diary" ref="sectionDiaryName">
      <div class="inf">
        <div>
          <h3>{{ $t('create_diary_view_diary_name') }}</h3>
        </div>

        <UiInput
            :text="diaryData.name"
            :error="nameError"
            type="text"
            :name="'name'"
            locator="diary_create_view_diary_name_locator"
            @change:text="(value: string) => {diaryData.name = value; handleNameInput()}"
            @input="markDirty()"
        />
      </div>

      <div v-if="diaryData.id && diaryData.id !== 'new'" class="ava">

        <h3 v-if="diaryData.id && diaryData.id !== 'new'" class="ava_title">{{ $t('create_diary_view_diary_cover') }}</h3>

        <img class="img" data-not-lazy :src="diaryData.avatar_small" alt="Cover">

        <div class="ava_btns">
          <DiaryEditUploadCover
            :diary_id="diaryData.id"
            locator="diary_create_view_upload_cover_locator"
            @changed="changedCover"
            @uploaded="uploadedCover"
          />
        </div>
      </div>
    </div>

    <!-- Seeds -->
    <h3 ref="sectionStrains">
      {{ $t('create_diary_view_strains_title') }}
    </h3>

    <p>
      {{ $t('create_diary_view_strains_subtitle') }}
    </p>
    
    <br>

    <div class="items">
      <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.Seed)" :key="item_key">
        <DiaryEditUniversalViewBox
          v-if="!item.is_remove"
          :item="item"
          :category="ProductCategoryType.Seed"
          locator="diary_create_view_delete_strain_locator"
          @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.Seed)"
          @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.Seed)"
        />
      </template>

      <DiaryEditUniversalSelectBox
        v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.Seed).length && !isMaxEquipmentReached(ProductCategoryType.Seed)"
        :category="ProductCategoryType.Seed"
        locator="diary_create_view_add_strain_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Seed)"
      />
      
      <DiaryEditUniversalEmptyBox
        v-else-if="!isMaxEquipmentReached(ProductCategoryType.Seed)"
        :error="strainsError"
        :is-hints-shown="isShowHints"
        :category="ProductCategoryType.Seed"
        locator="diary_create_view_add_strain_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Seed)"
      />

    </div>

    <!-- Room Type -->
    <h3 ref="sectionSetup">
      {{ $t('universal_room_type_title') }}
    </h3>

    <DiaryEditSelectRadioImgBox
      @choose="useDiary().changeTypeRoom(diaryData, $event)"
      :list="DiaryTypeRoomInfo"
      :is-hints-shown="isShowHints"
      :selected="diaryData.type_room"
      :locators="{
        [DiaryTypeRoom.Indoor]: 'diary_create_view_indoor_locator',
        [DiaryTypeRoom.Outdoor]: 'diary_create_view_outdoor_locator',
        [DiaryTypeRoom.Greenhouse]: 'diary_create_view_greenhouse_locator'
      }"
    />

    <!-- Grow Tent -->

    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor || diaryData.type_room === DiaryTypeRoom.Greenhouse">
      <h3>
        {{ $t('universal_tent_title') }}
      </h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.Tent)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.Tent"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_tent_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.Tent)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.Tent)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.Tent).length && !isMaxEquipmentReached(ProductCategoryType.Tent)"
          :category="ProductCategoryType.Tent"
          locator="diary_create_view_add_tent_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Tent)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.Tent)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.Tent"
          locator="diary_create_view_add_tent_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Tent)"
        />
      </div>
    </template>


    <!-- Vegetation Lights -->
    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor || diaryData.type_room === DiaryTypeRoom.Greenhouse">
      <h3 ref="sectionLights">
        {{ $t('universal_vegetation_lights_title') }}
      </h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.Lamp, ProductLampFaza.Vegetation)" :key="item_key">   
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.Lamp"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_lamp_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.Lamp)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.Lamp)"
            @clone="useDiary().cloneEquip(diaryData, item)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.Lamp, ProductLampFaza.Vegetation).length && !isMaxEquipmentReached(ProductCategoryType.Lamp)"
          :category="ProductCategoryType.Lamp"
          :faza="ProductLampFaza.Vegetation"
          locator="diary_create_view_add_lamp_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Lamp)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.Lamp)"
          :error="lampError"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.Lamp"
          :faza="ProductLampFaza.Vegetation"
          locator="diary_create_view_add_lamp_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Lamp)"
        />
      </div>
    </template>

    <!-- Flowering Lights -->
    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor || diaryData.type_room === DiaryTypeRoom.Greenhouse">
      <h3>
        {{ $t('universal_flowering_lights_title') }}
      </h3>

      <div class="clone">
        <span class="clone_btn" @click="useDiary().copyVegetationLamp(diaryData)">
          <i class="icon-clone"></i> {{ $t('create_diary_lamp_clone_vegetation') }}
        </span>
      </div>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.Lamp, ProductLampFaza.Flowering)" :key="item_key">          
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.Lamp"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_lamp_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.Lamp)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.Lamp)"
            @clone="useDiary().cloneEquip(diaryData, item)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.Lamp, ProductLampFaza.Flowering).length && !isMaxEquipmentReached(ProductCategoryType.Lamp)"
          :category="ProductCategoryType.Lamp"
          :faza="ProductLampFaza.Flowering"
          locator="diary_create_view_add_lamp_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Lamp)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.Lamp)"
          :error="lampError"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.Lamp"
          :faza="ProductLampFaza.Flowering"
          locator="diary_create_view_add_lamp_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Lamp)"
        />
      </div>
    </template>

    <!-- Ventilation Fans-->
    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor || diaryData.type_room === DiaryTypeRoom.Greenhouse">
      <h3>{{ $t('equip_ventilation_fans') }}</h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.VentilationFan)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.VentilationFan"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_ventilation_fan_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.VentilationFan)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.VentilationFan)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.VentilationFan).length && !isMaxEquipmentReached(ProductCategoryType.VentilationFan)"
          :category="ProductCategoryType.VentilationFan"
          locator="diary_create_view_add_ventilation_fan_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.VentilationFan)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.VentilationFan)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.VentilationFan"
          locator="diary_create_view_add_ventilation_fan_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.VentilationFan)"
        />
      </div>
    </template>

    <!-- Air Filters-->
    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor || diaryData.type_room === DiaryTypeRoom.Greenhouse">
      <h3>{{ $t('equip_air_filter') }}</h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.AirFilter)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.AirFilter"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_air_filter_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.AirFilter)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.AirFilter)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.AirFilter).length && !isMaxEquipmentReached(ProductCategoryType.AirFilter)"
          :category="ProductCategoryType.AirFilter"
          locator="diary_create_view_add_air_filter_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.AirFilter)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.AirFilter)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.AirFilter"
          locator="diary_create_view_add_air_filter_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.AirFilter)"
        />
      </div>
    </template>

    <!-- Air Conditioners-->
    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor || diaryData.type_room === DiaryTypeRoom.Greenhouse">
      <h3>{{ $t('equip_air_conditioner') }}</h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.AirConditioner)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.AirConditioner"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_air_conditioner_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.AirConditioner)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.AirConditioner)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.AirConditioner).length && !isMaxEquipmentReached(ProductCategoryType.AirConditioner)"
          :category="ProductCategoryType.AirConditioner"
          locator="diary_create_view_add_air_conditioner_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.AirConditioner)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.AirConditioner)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.AirConditioner"
          locator="diary_create_view_add_air_conditioner_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.AirConditioner)"
        />
      </div>
    </template>

    <!-- watering -->
    <h3>
      {{ $t('universal_watering_title') }}
    </h3>

    <DiaryEditSelectRadioImgBox
      @choose="useDiary().changeTypeWatering(diaryData, $event)"
      :is-hints-shown="isShowHints"
      :list="DiaryTypeWateringInfo"
      :selected="diaryData.type_watering"
      :locators="{
        [DiaryTypeWatering.Manual]: 'diary_create_view_type_manual_locator',
        [DiaryTypeWatering.Drip]: 'diary_create_view_type_drip_locator',
        [DiaryTypeWatering.Hydroponic]: 'diary_create_view_type_hydro_locator',
        [DiaryTypeWatering.Aeroponic]: 'diary_create_view_type_aero_locator'
      }"
    />

    <!-- Drip Systems -->
    <template v-if="diaryData.type_watering === DiaryTypeWatering.Drip">
      <h3>{{ $t('equip_drip_systems') }}</h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.DripSystem)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.DripSystem"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_drip_system_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.DripSystem)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.DripSystem)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.DripSystem).length && !isMaxEquipmentReached(ProductCategoryType.DripSystem)"
          :category="ProductCategoryType.DripSystem"
          locator="diary_create_view_add_drip_system_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.DripSystem)"
        />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.DripSystem)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.DripSystem"
          locator="diary_create_view_add_drip_system_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.DripSystem)"
        />
      </div>
    </template>

    <!-- Hydroponic Systems -->
    <template v-if="diaryData.type_watering === DiaryTypeWatering.Hydroponic">
      <h3>{{ $t('equip_hydroponic_systems') }}</h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.HydroponicSystem)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.HydroponicSystem"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_hydroponic_system_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.HydroponicSystem)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.HydroponicSystem)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.HydroponicSystem).length && !isMaxEquipmentReached(ProductCategoryType.HydroponicSystem)"
          :category="ProductCategoryType.HydroponicSystem"
          locator="diary_create_view_add_hydroponic_system_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.HydroponicSystem)"
        />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.HydroponicSystem)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.HydroponicSystem"
          locator="diary_create_view_add_hydroponic_system_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.HydroponicSystem)"
        />
      </div>
    </template>

    <!-- Controllers-->
    <h3>{{ $t('equip_controllers') }}</h3>

    <div class="items">
      <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.Controller)" :key="item_key">
        <DiaryEditUniversalViewBox
          :item="item"
          :category="ProductCategoryType.Controller"
          v-if="!item.is_remove"
          locator="diary_create_view_delete_controller_locator"
          @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.Controller)"
          @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.Controller)"
        />
      </template>

      <DiaryEditUniversalSelectBox
        v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.Controller).length && !isMaxEquipmentReached(ProductCategoryType.Controller)"
        :category="ProductCategoryType.Controller"
        locator="diary_create_view_add_controller_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Controller)"
      />
      <DiaryEditUniversalEmptyBox
        v-else-if="!isMaxEquipmentReached(ProductCategoryType.Controller)"
        :is-hints-shown="isShowHints"
        :category="ProductCategoryType.Controller"
        locator="diary_create_view_add_controller_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Controller)"
      />
    </div>


    <!-- substrates -->
    <h3 ref="sectionSubstrates">
      {{ $t('equip_substrates') }}
      <span class="medium_used">
        {{ $t('create_diary_grow_medium_used') }}
        {{ totalSubstratesVolume }}%
      </span>
    </h3>

    <!-- {{ useDiary().getItemsEquip(diaryData, ProductCategoryType.Substrate) }} -->

    <div class="items">
      <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.Substrate)" :key="item_key">
        <DiaryEditUniversalViewBox
          :item="item"
          :total-substrates-volume="totalSubstratesVolume"
          :category="ProductCategoryType.Substrate"
          v-if="!item.is_remove"
          locator="diary_create_view_delete_medium_locator"
          @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.Substrate)"
          @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.Substrate)"
        />
      </template>

      <DiaryEditUniversalSelectBox
        v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.Substrate).length && !isMaxEquipmentReached(ProductCategoryType.Substrate)"
        :category="ProductCategoryType.Substrate"
        locator="diary_create_view_add_medium_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Substrate)"
      />
      <DiaryEditUniversalEmptyBox
        v-else-if="!isMaxEquipmentReached(ProductCategoryType.Substrate)"
        :error="mediumError"
        :is-hints-shown="isShowHints"
        :category="ProductCategoryType.Substrate"
        locator="diary_create_view_add_medium_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.Substrate)"
      />
    </div>


    <!-- CO2 Generaots -->
    <h3>{{ $t('equip_co2_generators') }}</h3>

    <div class="items">
      <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.CO2Generator)" :key="item_key">
        <DiaryEditUniversalViewBox
          :item="item"
          :category="ProductCategoryType.CO2Generator"
          v-if="!item.is_remove"
          locator="diary_create_view_delete_co2_generator_locator"
          @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.CO2Generator)"
          @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.CO2Generator)"
        />
      </template>

      <DiaryEditUniversalSelectBox
        v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.CO2Generator).length && !isMaxEquipmentReached(ProductCategoryType.CO2Generator)"
        :category="ProductCategoryType.CO2Generator"
        locator="diary_create_view_add_co2_generator_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.CO2Generator)"
      />
      <DiaryEditUniversalEmptyBox
        v-else-if="!isMaxEquipmentReached(ProductCategoryType.CO2Generator)"
        :is-hints-shown="isShowHints"
        :category="ProductCategoryType.CO2Generator"
        locator="diary_create_view_add_co2_generator_locator"
        @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.CO2Generator)"
      />
    </div>


    <!-- Grow Boxes-->
    <template v-if="diaryData.type_room === DiaryTypeRoom.Indoor">
      <h3>{{ $t('equip_grow_boxes') }}</h3>

      <div class="items">
        <template v-for="(item, item_key) in useDiary().getItemsEquip(diaryData, ProductCategoryType.GrowBox)" :key="item_key">
          <DiaryEditUniversalViewBox
            :item="item"
            :category="ProductCategoryType.GrowBox"
            v-if="!item.is_remove"
            locator="diary_create_view_delete_growbox_locator"
            @remove="useDiary().deleteItemsEquip(diaryData, item, ProductCategoryType.GrowBox)"
            @choose="useDiary().changeItemsEquip(diaryData, item, $event, ProductCategoryType.GrowBox)"
          />
        </template>

        <DiaryEditUniversalSelectBox
          v-if="useDiary().getItemsEquip(diaryData, ProductCategoryType.GrowBox).length && !isMaxEquipmentReached(ProductCategoryType.GrowBox)"
          :category="ProductCategoryType.GrowBox"
          locator="diary_create_view_add_growbox_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.GrowBox)"
          />
        <DiaryEditUniversalEmptyBox
          v-else-if="!isMaxEquipmentReached(ProductCategoryType.GrowBox)"
          :is-hints-shown="isShowHints"
          :category="ProductCategoryType.GrowBox"
          locator="diary_create_view_add_growbox_locator"
          @choose="useDiary().addItemsEquip(diaryData, $event, ProductCategoryType.GrowBox)"
        />
      </div>
    </template>


    <h3>Diary Completion Progress</h3>
    <DiaryEditProgress
      :steps="progressSteps"
      :states="progressStates"
    />
 

    <div class="buttons">     
      
      <div v-if="isNameValid && isStrainsValid && isMediumValid && isLampValid" class="contest-state" :class="{'is-warning': isContestEligibilityWarning, 'is-success': isContestEligibilitySuccess}">
        <img loading="lazy" src="~/assets/icons/source/used/contest-cup.svg" class="contest-state-icon" />
        <span class="contest-state-text">
          {{ isContestEligibilitySuccess ? $t('create_diary_view_contest_hint_success') : $t('create_diary_view_contest_hint_fail')}}
        </span>
      </div>

      <div v-else class="contest-state is-blocked">
        <span class="contest-state-text">
          {{ $t('create_diary_view_contest_hint_fail_fail') }}
        </span>
      </div>
       
      <UiButton 
        type="primary wide-mobile" 
        :is-loading="isLoadingSave" 
        :name="$t('universal_button_save')" 
        locator="diary_create_view_save_button_locator" 
        @click="save"
      />
      <UiButton 
        type="wide-mobile" 
        v-if="diaryData.id" 
        :name="$t('universal_button_cancel')" 
        @click="cancel"
      />
      

      <span v-if="isDraftSaved">{{ $t('create_diary_view_presave_draft_saved') }}</span>
    </div>


  </div> 
  <div v-else-if="diaryData?.id && !allowEdit">
    <UiNoAccess />
  </div>

  <br>
</template>




<script setup lang="ts">

import type { DiaryEquip, Diary, DiaryMedium }  from "@/types/diary";
import { createDiary, DiaryTypeRoom, DiaryTypeWatering, DiaryTypeRoomInfo, DiaryTypeWateringInfo }  from "@/types/diary";
import { ProductCategoryType, ProductLampFaza }  from "@/types/product";
import { ProgressStep } from "@/types/other";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const {$api, $ga, $scrollto, $presaver, $head} = useNuxtApp()

const isLoadingSave = ref(false);
const elDiarySignup = ref(null);
const signupStartAuth = ref(false);
const elSignupForm = ref(null);
const isLoadedPresaver = ref(false);
const isDraftSaved = ref(false);
const link = ref<string>(typeof route.params.id === 'string' ? route.params.id : route.params.id[0]);
const id = ref<number>(parseInt(link.value));
const getPresaverKey = () => {
  const userId = useAuth().getId() || 'guest';
  return `${id.value}_${userId}`;
};
const presaver = $presaver(getPresaverKey(), 'diary');
const isWarnedEmptySeedProducts = ref(false);
const isNewDiary = computed(() => link.value === 'new');
const enablePresaver = computed(() => link.value === 'new'); 
const signupShortRef = ref(null);
const isShowHints = ref(false);
const sectionDiaryName = ref(null);
const sectionStrains = ref(null);
const sectionSetup = ref(null);
const sectionLights = ref(null);
const sectionSubstrates = ref(null);
const eligibleForContestState = ref(0);
const isNameDirty = ref(false);

definePageMeta({
  middleware: ['auth-redirect']   
})

const def = ref({
  id: id.value,
  items_equip: [],
  items_lamp_flo: [],
  items_lamp_veg: [],
  items_medium: [],
  name: null,
  type_room: 1,
  type_watering: null
});

const progressSteps = ref([
  {
    id: 'name',
    name: t('create_diary_view_navigation_dairy_name'),
    el: sectionDiaryName,
  },
  {
    id: 'strains',
    name: t('create_diary_view_navigation_strains'),
    el: sectionStrains,
  },
  {
    id: 'setup',
    name: t('create_diary_view_navigation_setup'),
    el: sectionSetup,
  },
]);


const progressStates = computed(() => useDiary().calculateProgress(diaryData.value));

const totalMedium = computed(() => useDiary().calculateTotalMedium(diaryData.value));
const totalSubstratesVolume = computed(() => useDiary().calculateTotalSubstratesVolume(diaryData.value));

 
const cancel = function() {
  var url = isNewDiary.value ? '/explore' : id.value;

  if (isNewDiary.value) {
    var url = '/explore';
  } else {
    var url = diaryData.value.link;
  }
  
  clearDraft();

  router.push({
    path: url
  })
}

const nameError = ref('');
const strainsError = ref('');
const lampError = ref('');
const mediumError = ref('');

const MAX_STRAIN_COUNT = 8
const MAX_EQUIPMENT_COUNT = 10
const DIARY_NAME_MIN_CHAR = 5
const DIARY_NAME_MAX_CHAR = 40

const handleNameInput = () => {
  if (isNameDirty.value && !isNameValid.value) {
    nameError.value = t('create_diary_view_error_dairy_name_format');
  } else {
    nameError.value = '';
  }
};

const markDirty = () => {
  if (!isNameDirty.value) {
    isNameDirty.value = true;
  }
}

const isMaxStrainsReached = computed(() => diaryData.value.items_equip?.filter(
    (item: DiaryEquip) => item?.category === ProductCategoryType.Seed && !item.is_remove && (item.id || item.name))?.length === MAX_STRAIN_COUNT
)

const isMaxEquipmentReached = (category: ProductCategoryType) => {
  if (category === ProductCategoryType.Seed) {
    return isMaxStrainsReached.value;
  }
  
  return diaryData.value.items_equip?.filter(
    (item: DiaryEquip) => item?.category === category && !item.is_remove && (item.id || item.name)
  )?.length >= MAX_EQUIPMENT_COUNT;
}

const isNameValid = computed(() => {
  return diaryData.value.name && diaryData.value.name.length >= DIARY_NAME_MIN_CHAR && diaryData.value.name.length <= DIARY_NAME_MAX_CHAR;
});

const isStrainsValid = computed(() => {
  return useDiary().isExistsSeedList(diaryData.value);
});

const isMediumValid = computed(() => {
  const substrateItems = diaryData.value.items_equip
    ?.filter((item: DiaryEquip) => 
      item.category === ProductCategoryType.Substrate && 
      item.is_remove !== 1
    ) || [];
  
  const totalSubstrateVolume = substrateItems.reduce((total: number, item: DiaryEquip) => {
    return total + Number(item.props?.volume || 0);
  }, 0);
  
  return totalSubstrateVolume > 0;
});

const isLampValid = computed(() => {
  return diaryData.value.type_room === DiaryTypeRoom.Indoor ?
      diaryData.value.items_equip.some((item: DiaryEquip) => item.category === ProductCategoryType.Lamp) :
      true;
});

const isValid = function() {

  if (!isNameValid.value) {
    scrollToSection(sectionDiaryName.value)
    nameError.value = t('create_diary_view_error_dairy_name_format')
    return false;
  }

  if (!isStrainsValid.value) {
    scrollToSection(sectionStrains.value)    
    strainsError.value = t('create_diary_view_error_strain_count');
    return false;
  }

  if (useDiary().isEmptySeedName(diaryData.value)) {
    useToast().error('Please fill in the strain names for breeders. Otherwise, they will be saved with the name "Custom" when you save.');
    isWarnedEmptySeedProducts.value = true;
    scrollToSection(sectionStrains.value);
    return false;
  }

  if (!isMediumValid.value) {
    scrollToSection(sectionSubstrates.value);
    mediumError.value = t('create_diary_view_error_medium_count');
    return false;
  }

  if (!isLampValid.value) {
    scrollToSection(sectionLights.value);
    lampError.value = t('create_diary_view_error_lights_count');


  // if (!diaryData.value.name) {
  //   $scrollto({
  //     el: elDiaryName,
  //     offset: 130,
  //   })

  //   useToast().error('Empty diary name');
  //   return false;
  // }

  // if (!diaryData.value.type_room) {
  //   $scrollto({
  //     el: elDiarySetup,
  //     offset: 130,
  //   })

  //   useToast().error('Empty room type');
  //   return false;
  // }

  // if (!useDiary().isValidSeedList(diaryData.value)) {
  //   isWarnedEmptySeedProducts.value = true;
  //   $scrollto({ el: elDiarySeeds, offset: 130 })
  //   useToast().error(t('create_diary_view_error_strain_count'));
  //   return false;
  // }

  // if (useDiary().isEmptySeedName(diaryData.value)) {
  //   isWarnedEmptySeedProducts.value = true;
  //   $scrollto({ el: elDiarySeeds, offset: 130 })
  //   useToast().error(t('create_diary_view_error_strain_fill_auto'));

    return false;
  }

  return true;
}

const scrollToSection = (section) => {
  let targetRef = section;

  if (targetRef) {
    $scrollto({
      el: targetRef,
      offset: 100,
    });
  }
};

const handleSignupError = (error: any) => {
  isLoadingSave.value = false;
}

const save = async function() {
  isLoadingSave.value = true

  // if (!useAuth().isAuth()) {
  //   await nextTick();

  //   if (elDiarySignup.value) {
  //     $scrollto({
  //       el: elDiarySignup.value,
  //       offset: 130,
  //     })
  //   }

  //   if(!signupShortRef.value){
  //     isLoadingSave.value = false;
  //     return false;
  //   }

  //   const success = await signupShortRef.value.signUpHandler();
  //   if (!success) {
  //     isLoadingSave.value = false;
  //     return false;
  //   }
  // }

  if(isWarnedEmptySeedProducts.value){
    useDiary().fillEmptyProductsName(diaryData.value);
  }

  if (!isValid()) {
    isLoadingSave.value = false;
    return false;
  }

  const copyDiaryData = JSON.parse(JSON.stringify(diaryData.value))
  copyDiaryData.items_equip = copyDiaryData.items_equip.filter((item: DiaryEquip) => item)

  if (!copyDiaryData.id) {
    $api.postDiary(copyDiaryData)
      .then((res) => {
        var data = res.data;
        useToast().success(t('create_diary_view_message_success'));
        //$ga.addDiary();// is old
        $ga.eventGA('contribute_content_diary');
        if(data.is_first_diary)
          $ga.eventGA('contribute_content_1st_diary');
        isLoadingSave.value = false;
        presaver.clearType('diary');
        router.push(data.link);
      })
      .catch(function (error) {
        isLoadingSave.value = false;
        useToast().error(t('create_diary_view_error_failed'));
      });
  } else {
    $api.putDiary(copyDiaryData.id, copyDiaryData)
      .then((res) => {
        var data = res.data;
        useToast().success('Diary successfully saved');
        isLoadingSave.value = false;
        presaver.clearType('diary');
        console.log('data', data, data.link)
        router.push(data.link);
        presaveClear();
      })
      .catch(function (error) {
        console.log(error);
        useToast().error(t('create_diary_view_error_failed'));
        isLoadingSave.value = false;
      });
  }
}

const changedCover = function(uploading_id: string) {
  // console.log('loading', uploading_id)
}

const uploadedCover = function(data: string) {
  diaryData.value.avatar_small = data;
}

const presaveClear = async function() {
  isLoadedPresaver.value = false;
  presaver.clearType('diary');
  isDraftSaved.value = false;
  diaryData.value = await loadData(id.value);
}

const clearDraft = async function() {
  try {
    presaver.clearType('diary');
    isLoadedPresaver.value = false;
    isDraftSaved.value = false;

    strainsError.value = '';
    lampError.value = '';
    mediumError.value = '';

    diaryData.value = await loadData(id.value);
  } catch (error) {
    useToast().error(t('Error clearing draft'));
  }
}

const allowEdit = computed(() => {
  if (!diaryData.value.id)
    return true;

  if (diaryData.value.item_user.id == useAuth().getId())
    return true;

  return false;
});

const loadData = async function(id: number) {
  if (enablePresaver.value && presaver.exists()) {
    const presavedData = presaver.get();
    if (JSON.stringify(presavedData) !== JSON.stringify(createDiary())) {
      isLoadedPresaver.value = true;
      return presavedData;
    }
  }

  if (isNewDiary.value) {
    return createDiary();
  }

  return await $api.getDiary(id)
}


const { status: statusDiaryData,  data: diaryData } = await useLazyAsyncData('editDiaryData' + id.value, async () => await loadData(id.value))

watch(() => diaryData, (new_diaryData) => {
  if (enablePresaver.value && new_diaryData.value) {
    presaver.set(new_diaryData.value);
    isDraftSaved.value = true;
  }
}, {deep: true});

watch(() => useAuth().getId(), () => {
  const newPresaverKey = getPresaverKey();
  Object.assign(presaver, $presaver(newPresaverKey, 'diary'));
  
  if (presaver.exists()) {
    const presavedData = presaver.get();
    if (JSON.stringify(presavedData) !== JSON.stringify(createDiary())) {
      isLoadedPresaver.value = true;
      diaryData.value = presavedData;
    }
  }
});

onMounted(() => {
  useHead($head.getForDiaryEdit())
  if (presaver.exists()) {
    const presavedData = presaver.get();
    if (JSON.stringify(presavedData) !== JSON.stringify(createDiary())) {
      isLoadedPresaver.value = true;
      diaryData.value = presavedData;
      useToast().success(t('create_diary_view_message_autosave_loaded'));
    }
  }
});

const isContestEligibilitySuccess = computed(() => {
  const progress = useDiary().calculateProgress(diaryData.value);
  return progress.name === ProgressStep.Good &&
         progress.strains === ProgressStep.Good &&
         progress.setup === ProgressStep.Good;
});

const isContestEligibilityWarning = computed(() => {
  const progress = useDiary().calculateProgress(diaryData.value);
  return !isContestEligibilitySuccess.value && (
    progress.name === ProgressStep.Normal ||
    progress.strains === ProgressStep.Normal ||
    progress.setup === ProgressStep.Normal
  );
});

onUnmounted(() => $head.setManualPath())
</script>

<style scoped>

h1,
h2,
h3{
  margin-top: 1rem;
  margin-bottom: 0.6rem;
}

.medium_used {
  color: var(--un-text-color-firm);
}

.warn {
  position: relative;
  min-height: 1em;
  margin: 1em 0;
  padding: 1em 1.5em;
  line-height: 1.4285em;
  color: rgba(0, 0, 0, 0.87);
  -webkit-transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease, box-shadow 0.1s ease;
  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease, box-shadow 0.1s ease;
  border-radius: 0.28571429rem;
  background-color: #FFF8DB;
  color: #B58105;
  box-shadow: 0px 0px 0px 1px #b58105 inset, 0px 0px 0px 0px rgb(0 0 0 / 0%);
}
.items{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  /* align-items: flex-start; */
}

.title {
  text-align: center;
}

.hints-toggle {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.head_diary{
  display: flex;
  align-items: center;
  gap:1rem;
  margin-top: 1rem;
}
.head_diary .inf{
  width: 100%;
}
.head_diary .ava{
  width: 130px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.head_diary .ava_title{
  display: none;
}
.head_diary .ava .img{
  aspect-ratio: 1/1;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.head_diary .ava .ava_btns{
  width: 100%;
  margin-top: -35px;
}
@media screen and (max-width: 600px){
  .head_diary .ava{
    width: 100px;
  } 
}

.clone{
  margin-bottom: 0.5rem;
}
.clone_btn{
  cursor: pointer;
}

.buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
}

.buttons span {
  color: #B2B2B2;
}

.contest-state {
  display: flex;
  align-items: center;
  gap: 8px;
  /* padding: 16px; */
  border-radius: 10px;
  /* margin-bottom: 16px; */
  width: 100%;
  padding: 1rem;
}

.contest-state span {
  /* font-size: 12px; */
}

.contest-state.is-warning {
  background-color: #FEF8DE;
  /* border: 1px solid #B58105; */
}

.contest-state.is-warning span {
  color: #B58105;
}

.contest-state.is-success {
  /* background-color: var(--new-un-general-color-light-green); */
  /* border: 1px solid var(--new-un-general-color-green); */
}

.contest-state.is-success span {
  /* color: var(--new-un-general-color-green); */
}

.contest-state.is-blocked {
  justify-content: center;
  /* background-color: var(--new-un-general-color-light-red); */
  /* border: 1px solid var(--new-un-general-color-red); */
  /* margin-bottom: 16px; */
  width: 100%;
}

.contest-state.is-blocked span {
  color: var(--new-un-general-color-orange);
}

.contest-state-icon {
  width: 34px;
  height: 39px;
}

/* .presaver-message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  background-color: #D2E8F4;
  padding: 16px;
  gap: 8px;
  color: #5078A2;
}

.presaver-message-clear {
  font-weight: 510;
  font-size: 14px;
  line-height: 120%;
  text-decoration-style: solid;
  cursor: pointer;
} */
</style>